import routerOptions0 from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}